
import React from 'react';

import CircularProgress from '@material-ui/core/CircularProgress';

import ErrorPanel from '../../components/ErrorPanel';

import { Dialog } from '../../hooks/useDialog';

import Order from './OrderItem';

const Main = (props) => {
    const { editorState, account, actions } = props;

    React.useEffect(() => {

        actions.loadOrders();

        const update = (ev) => {
            if (ev.key === 'portfolioDeleted' && ev.newValue === 'true') {
                if (!account.loading) {
                    actions.loadOrders();
                }
            }
        };

        window.addEventListener("storage", update);

        return () => {
            window.removeEventListener('storage', update);
        }
    }, []);

    const { orders = [], } = account.orders;

    return <div>
        {(account.loading || account.portfolioDeleting) && <div style={{ textAlign: 'center', margin: 60 }}>
            <div><CircularProgress /></div>
            <div>Loading...</div>
        </div>}
        {editorState.copying && <div>
            <Dialog maxWidth='sm' fullWidth='true' actionButtons={[]}>
                <div style={{ textAlign: 'center', margin: 60 }}>
                    <div><CircularProgress /></div>
                    <div>Copying...</div>
                </div>
            </Dialog>
        </div>}
        {account.error && <div>
            <ErrorPanel error={account.error} />
        </div>}
        {!account.loading && !account.portfolioDeleting && !account.error && <div>
            {orders.length === 0 && <div>
                You have no orders.
            </div>}
            {orders.length > 0 && <div>
                {orders.map(e => <Order {...props} order={e} key={`ord_${e.id}`} />)}

            </div>}
        </div>}
    </div>
}

export default Main;



// WEBPACK FOOTER //
// ./src/account/components/MyOrders.js